import { axiosClientv1 } from "./apiClient";
import { ApiResponse, ThicknessGauge } from "../Types";

export const GetThicknessGauges = async (): Promise<
  ApiResponse<ThicknessGauge[]>
> => {
  try {
    const response = await axiosClientv1.get(`/thickness-gauges/active`);
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message:
        error?.response?.data?.message || "Failed to load thickness gauges.",
      data: [],
      error: { code: error?.response?.status || 500, type: "server_error" },
    };
  }
};

export const CreateThicknessGauge = async (formData: {
  name: string;
  thickness_mm: number;
  gauge_val?: string;
}): Promise<ApiResponse<ThicknessGauge>> => {
  try {
    const response = await axiosClientv1.post(
      `/thickness-gauges/create`,
      formData,
    );
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message:
        error?.response?.data?.message || "Failed to create thickness gauge.",
      error: { code: error?.response?.status || 400, type: "bad_request" },
    };
  }
};

export const UpdateThicknessGauge = async (formData: {
  id: string;
  name: string;
  thickness_mm: number;
  gauge_val?: string;
}): Promise<ApiResponse<ThicknessGauge>> => {
  try {
    const response = await axiosClientv1.post(
      `/thickness-gauges/update`,
      formData,
    );
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message:
        error?.response?.data?.message || "Failed to update thickness gauge.",
      error: { code: error?.response?.status || 400, type: "bad_request" },
    };
  }
};

export const DeleteThicknessGauge = async (
  id: string,
): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.post(`/thickness-gauges/delete`, {
      id,
    });
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message:
        error?.response?.data?.message || "Failed to delete thickness gauge.",
      error: { code: error?.response?.status || 400, type: "bad_request" },
    };
  }
};
